(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("Totem");

  Components.create('Totem', {

    bindEvents: function() {
      const radioButtons = $('input[name="selectedStores"]');
      const storeConfirm = $('.store-confirm');

      const isAutoRedirect = $('.js-auto-redirect');

      radioButtons.each(function () {
        $(this).on('change', () => {
          storeConfirm.removeClass('hide');
          const selectedStore = $(this).closest('.select-store');
          const selectedStoreName = selectedStore.data('store-name');
          const selectedStoreId =  selectedStore.data('store-id');
          $('.js-selected-store-name').text(selectedStoreName);
          $('.js-selected-store').attr('value',selectedStoreId);
        });
      });

      $(document).on('click','.js-vex-close',()=>{
        vex.closeAll();
      })
      

      if(isAutoRedirect.length > 0){
        document.addEventListener('DOMContentLoaded', function(){
          setTimeout(function(){
            window.location.href = isAutoRedirect.data('redirect');
          },30000);

        });
      }
     
    },

    init: function() {
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
